<template>
  <div class="declaration">
    <el-divider content-position="left">记账报税时间提醒</el-divider>
    <div style="display: flex">
      <el-date-picker
        v-model="selectYear"
        type="year"
        size="mini"
        format="yyyy"
        value-format="yyyy"
        @change="doSearchYear"
        placeholder="选择年"
      >
      </el-date-picker>
      <el-date-picker
        v-model="selectMonth"
        size="mini"
        style="margin-left: 0.1rem"
        type="month"
        @change="doSearchMonth"
        format="MM"
        value-format="MM"
        placeholder="选择月"
      >
      </el-date-picker>
      <div style="flex: 1; text-align: right">
        <el-button type="primary" @click="dialog = true" size="mini">录入</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 10px"
      size="mini"
      height="calc(100vh - 256px)"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="year" label="年" width="80" fixed> </el-table-column>
      <el-table-column prop="decladate" label="提醒月份" width="80" fixed="left">
      </el-table-column>
      <el-table-column prop="material" label="记账材料交接" width="180">
      </el-table-column>
      <el-table-column prop="tax" label="本月报税期" width="100"> </el-table-column>
      <el-table-column prop="card" label="清卡截止日期" width="130"> </el-table-column>
      <el-table-column prop="social_insu" label="社保公积金办理日期" width="180">
      </el-table-column>
      <el-table-column prop="zerodesc" label="有票小规模企业提醒事项" width="220">
      </el-table-column>
      <el-table-column prop="normaldesc" label="有票一般纳税人企业提醒事项" width="220">
      </el-table-column>
      <el-table-column prop="nzerodesc" label="0申报小规模企业提醒事项" width="220">
      </el-table-column>
      <el-table-column prop="nnormaldesc" label="0申报一般纳税人企业提醒事项" width="220">
      </el-table-column>
      <el-table-column label="操作" width="70" fixed="right">
        <template slot-scope="scope">
          <el-tooltip placement="top" content="修改">
            <el-button
              @click="editRemind(scope.$index, tableData)"
              type="primary"
              circle
              icon="el-icon-edit"
              size="small"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="录入"
      :before-close="handleClose"
      :visible.sync="dialog"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawer"
      size="40%"
    >
      <div class="demo-drawer__content" style="padding: 0.2em 1.4em; margin-top: -30px">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="选择年份" required>
            <el-col :span="11">
              <el-form-item prop="choyear">
                <el-date-picker
                  format="yyyy"
                  value-format="yyyy"
                  type="year"
                  placeholder="选择年份"
                  v-model="ruleForm.choyear"
                  style="width: 100%"
                  size="mini"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="选择月份" required>
            <el-col :span="11">
              <el-form-item prop="chomonth">
                <el-date-picker
                  format="M"
                  value-format="M"
                  type="month"
                  placeholder="选择月份"
                  v-model="ruleForm.chomonth"
                  style="width: 100%"
                  size="mini"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="记账材料" required>
            <el-col :span="11">
              <el-form-item prop="material">
                <el-date-picker
                  v-model="ruleForm.material"
                  type="daterange"
                  start-placeholder="办理开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  size="mini"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="本月报税期" required>
            <el-col :span="11">
              <el-form-item prop="tax">
                <el-date-picker
                  size="mini"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  v-model="ruleForm.tax"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="清卡截止日" required>
            <el-col :span="11">
              <el-form-item prop="card">
                <el-date-picker
                  size="mini"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  v-model="ruleForm.card"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="社保公积金" required>
            <el-col :span="11">
              <el-form-item prop="social_insu">
                <el-date-picker
                  v-model="ruleForm.social_insu"
                  type="daterange"
                  start-placeholder="办理开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  size="mini"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="0申报小规模" prop="nzerodesc" label-width="120px">
            <el-input
              type="textarea"
              size="mini"
              v-model="ruleForm.nzerodesc"
              placeholder="无票0申报小规模纳税人企业提醒事项"
            ></el-input>
          </el-form-item>
          <el-form-item prop="nnormaldesc" label="0申报一般纳税人" label-width="120px">
            <el-input
              type="textarea"
              size="mini"
              v-model="ruleForm.nnormaldesc"
              placeholder="无票一般纳税人企业提醒事项"
            ></el-input>
          </el-form-item>
          <el-form-item label="有票小规模" prop="zerodesc" label-width="120px">
            <el-input
              type="textarea"
              size="mini"
              v-model="ruleForm.zerodesc"
              placeholder="有票0申报小规模纳税人企业提醒事项"
            ></el-input>
          </el-form-item>
          <el-form-item prop="normaldesc" label="有票一般纳税人" label-width="120px">
            <el-input
              type="textarea"
              size="mini"
              v-model="ruleForm.normaldesc"
              placeholder="有票一般纳税人企业提醒事项"
            ></el-input>
          </el-form-item>
          <el-form-item style="text-align: right">
            <el-button type="primary" @click="submitForm('ruleForm')" size="mini"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :before-close="handleClose"
      :visible.sync="editDialog"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawers"
      size="40%"
      id="edit"
    >
      <div class="demo-drawer__content" style="padding: 0 10px; margin-top: -30px">
        <el-form
          :model="editForm"
          :rules="editrules"
          ref="editForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="年份" required>
            <el-col :span="11">
              <el-form-item prop="choyear">
                <el-input size="mini" v-model="editForm.choyear" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="月份" required>
            <el-col :span="11">
              <el-form-item prop="chomonth">
                <el-input size="mini" v-model="editForm.chomonth" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="记账材料" required>
            <el-col :span="11">
              <el-form-item prop="material">
                <el-date-picker
                  v-model="editForm.material"
                  type="daterange"
                  start-placeholder="办理开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  size="mini"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="本月报税期" required>
            <el-col :span="11">
              <el-form-item prop="tax">
                <el-date-picker
                  size="mini"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  v-model="editForm.tax"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="清卡截止日" required>
            <el-col :span="11">
              <el-form-item prop="card">
                <el-date-picker
                  size="mini"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  v-model="editForm.card"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="社保公积金" required>
            <el-col :span="11">
              <el-form-item prop="social_insu">
                <el-date-picker
                  v-model="editForm.social_insu"
                  type="daterange"
                  start-placeholder="办理开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  size="mini"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="0申报小规模" prop="nzerodesc" label-width="120px">
            <el-input
              type="textarea"
              size="mini"
              v-model="editForm.nzerodesc"
              placeholder="0申报小规模纳税人企业提醒事项"
            ></el-input>
          </el-form-item>
          <el-form-item prop="nnormaldesc" label="0申报一般纳税人" label-width="120px">
            <el-input
              type="textarea"
              size="mini"
              v-model="editForm.nnormaldesc"
              placeholder="0申报一般纳税人企业提醒事项"
            ></el-input>
          </el-form-item>
          <el-form-item label="有票小规模" prop="zerodesc" label-width="120px">
            <el-input
              type="textarea"
              size="mini"
              v-model="editForm.zerodesc"
              placeholder="有票小规模纳税人企业提醒事项"
            ></el-input>
          </el-form-item>
          <el-form-item prop="normaldesc" label="有票一般纳税人" label-width="120px">
            <el-input
              type="textarea"
              size="mini"
              v-model="editForm.normaldesc"
              placeholder="有票一般纳税人企业提醒事项"
            ></el-input>
          </el-form-item>
          <el-form-item style="text-align: right">
            <el-button type="primary" @click="editSubmitForm('editForm')" size="mini"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <div class="page-footer">
      <el-pagination
        class="pagination-style"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="needpage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "Declaration",
  data() {
    return {
      pageSize: 30,
      selectYear: "",
      selectMonth: "",
      decladate: "",
      activeNames: "",
      remindId: "",
      total: 0,
      material: "",
      tax: "",
      card: "",
      dialog: false,
      editDialog: false,
      tableData: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      options: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "一月",
          label: "一月",
        },
        {
          value: "二月",
          label: "二月",
        },
        {
          value: "三月",
          label: "三月",
        },
        {
          value: "四月",
          label: "四月",
        },
        {
          value: "五月",
          label: "五月",
        },
        {
          value: "六月",
          label: "六月",
        },
        {
          value: "七月",
          label: "七月",
        },
        {
          value: "八月",
          label: "八月",
        },
        {
          value: "九月",
          label: "九月",
        },
        {
          value: "十月",
          label: "十月",
        },
        {
          value: "十一月",
          label: "十一月",
        },
        {
          value: "十二月",
          label: "十二月",
        },
      ],
      ruleForm: {
        choyear: "",
        chomonth: "",
        material: [],
        tax: "",
        card: "",
        delivery: false,
        nzerodesc: "",
        zerodesc: "",
        smalldesc: "",
        normaldesc: "",
        nnormaldesc: "",
        social_insu: [],
      },
      editForm: {
        choyear: "",
        chomonth: "",
        material: [],
        tax: "",
        card: "",
        delivery: false,
        zerodesc: "",
        nzerodesc: "",
        normaldesc: "",
        nnormaldesc: "",
        social_insu: [],
      },
      needpage: "",
      rules: {
        choyear: [{ required: true, message: "请选择年份", trigger: "change" }],
        chomonth: [{ required: true, message: "请选择日期", trigger: "change" }],
        material: [{ required: true, message: "请选择日期", trigger: "change" }],
        tax: [{ required: true, message: "请选择时间", trigger: "change" }],
        social_insu: [{ required: true, message: "请选择时间", trigger: "change" }],
        card: [{ required: true, message: "请选择时间", trigger: "change" }],
        zerodesc: [{ max: 500, message: "长度不能超过500个字符", trigger: "change" }],
        smalldesc: [{ max: 500, message: "长度不能超过500个字符", trigger: "change" }],
        normaldesc: [{ max: 500, message: "长度不能超过500个字符", trigger: "change" }],
      },
      editrules: {
        chomonth: [{ required: true, message: "请选择日期", trigger: "change" }],
        material: [{ required: true, message: "请选择日期", trigger: "change" }],
        tax: [{ required: true, message: "请选择时间", trigger: "change" }],
        social_insu: [{ required: true, message: "请选择时间", trigger: "change" }],
        card: [{ required: true, message: "请选择时间", trigger: "change" }],
        zerodesc: [{ max: 500, message: "长度不能超过500个字符", trigger: "change" }],
        smalldesc: [{ max: 500, message: "长度不能超过500个字符", trigger: "change" }],
        normaldesc: [{ max: 500, message: "长度不能超过500个字符", trigger: "change" }],
      },
      formLabelWidth: "180px",
    };
  },
  created() {
    return this.loadRemind();
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    doSearchMonth(val) {
      this.needpage = 1;
      this.loadRemind(1);
    },
    doSearchYear(val) {
      this.needpage = 1;
      this.loadRemind(1);
    },
    monthUp(m) {
      if (m === "1") {
        return "一月";
      }
      if (m === "2") {
        return "二月";
      }
      if (m === "3") {
        return "三月";
      }
      if (m === "4") {
        return "四月";
      }
      if (m === "5") {
        return "五月";
      }
      if (m === "6") {
        return "六月";
      }
      if (m === "7") {
        return "七月";
      }
      if (m === "8") {
        return "八月";
      }
      if (m === "9") {
        return "九月";
      }
      if (m === "10") {
        return "十月";
      }
      if (m === "11") {
        return "十一月";
      }
      if (m === "12") {
        return "十二月";
      }
    },
    loadRemind(page) {
      this.$axios
        .get("/api/decla/getinfo?page=" + page + "&page-size=" + this.pageSize, {
          params: {
            year: this.selectYear,
            month: this.selectMonth,
          },
        })
        .then((res) => {
          if (res.data.code === 1) {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error("获取数据失败");
        });
    },
    clearinput() {
      this.material = "";
      this.tax = "";
      this.card = "";
      this.decladate = "";
    },
    inputsearch() {
      var smonth = this.selectMonth;
      if (smonth === "全部") {
        smonth = "";
      }
      this.$axios
        .get("/api/decla/getinfo?decladate=" + smonth)
        .then((res) => {
          if (res.data.code === 1) {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          }
        })
        .catch(() => {
          this.$message.error("获取数据失败");
        });
    },
    handleClose(done) {
      this.$confirm("确定要关闭吗？")
        .then((_) => {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            done();
          });
        })
        .catch((_) => {});
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    declasuccess() {
      this.$message({
        message: "恭喜你，添加成功",
        type: "success",
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var cmonth = this.monthUp(this.ruleForm.chomonth);
          var mat = this.ruleForm.material;
          var ta = this.ruleForm.tax;
          var car = this.ruleForm.card;
          var zdesc = this.ruleForm.zerodesc;
          var nzdesc = this.ruleForm.nzerodesc;
          var ndesc = this.ruleForm.normaldesc;
          var nndesc = this.ruleForm.nnormaldesc;
          var socialinsu = this.ruleForm.social_insu;
          this.$axios
            .post("/api/decla/addinfo", {
              material: mat,
              decladate: cmonth,
              tax: ta,
              card: car,
              zerodesc: zdesc,
              nzerodesc: nzdesc,
              normaldesc: ndesc,
              nnormaldesc: nndesc,
              social_insu: socialinsu,
              year: this.ruleForm.choyear,
            })
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.$message({
                  message: data.msg,
                  type: "success",
                });
                this.dialog = false;
                this.loadRemind(this.needpage);
                this.selectMonth = "";
                this.$refs["ruleForm"].resetFields();
              } else {
                this.$message.error(data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var chomonth = this.editForm.chomonth;
          var mat = this.editForm.material;
          var ta = this.editForm.tax;
          var car = this.editForm.card;
          var zdesc = this.editForm.zerodesc;
          var nzdesc = this.editForm.nzerodesc;
          var ndesc = this.editForm.normaldesc;
          var nndesc = this.editForm.nnormaldesc;
          var socialinsu = this.editForm.social_insu;
          this.$axios
            .post("/api/decla/doeditinfo", {
              decladate: chomonth,
              material: mat,
              tax: ta,
              card: car,
              zerodesc: zdesc,
              nzerodesc: nzdesc,
              normaldesc: ndesc,
              nnormaldesc: nndesc,
              social_insu: socialinsu,
              id: this.remindId,
            })
            .then((res) => {
              if (res.data.code === 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.editDialog = false;
                this.loadRemind(this.needpage);
                this.selectMonth = "";
                this.$refs["editForm"].resetFields();
              }
            })
            .catch(() => {
              this.$message.error("修改失败");
            });
        }
      });
    },
    handlePageChange(val) {
      this.needpage = val;
      this.loadRemind(val);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadRemind(1);
    },
    handleCurrentChange(val) {
      this.needpage = val;
      this.loadRemind(val);
    },
    editRemind(index, rows) {
      this.editForm.choyear = rows[index].year;
      this.remindId = rows[index].id;
      this.editDialog = true;
      this.$axios
        .post("/api/decla/editinfo", {
          id: this.remindId,
        })
        .then((res) => {
          if (res.data.code === 1) {
            this.editForm.chomonth = res.data.data.decladate;
            this.editForm.material = res.data.data.material;
            this.editForm.tax = res.data.data.tax;
            this.editForm.card = res.data.data.card;
            this.editForm.zerodesc = res.data.data.zerodesc;
            this.editForm.nzerodesc = res.data.data.nzerodesc;
            this.editForm.normaldesc = res.data.data.normaldesc;
            this.editForm.nnormaldesc = res.data.data.nnormaldesc;
            this.editForm.social_insu = res.data.data.social_insu;
          }
        })
        .catch(() => {
          this.$message.error("获取数据失败");
        });
    },
  },
};
</script>
<style>
.declaration {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 25px !important;
  text-align: right;
}

.declaration .el-collapse {
  border-top: none;
}
.declaration .el-collapse-item__header {
  color: #4c87fc;
  font-weight: bold;
  padding-left: 1%;
}
.s-wamp {
  text-align: center;
  padding-top: 40px;
}
.declaration .inline-block {
  display: inline-block;
  margin-left: 12px;
}
.el-date-editor--daterange.el-input__inner {
  width: 9.1rem;
}
#edit .el-date-editor--daterange.el-input__inner {
  width: 9.5rem;
}
.el-col-11 {
  width: 100%;
}
.el-range-editor--mini .el-range-input {
  margin-left: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/declaration/Declaration.vue